import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import logger from 'redux-logger'
import thunk from 'redux-thunk'

import account from './reducers/account'
import app from './reducers/app'
import auth from './reducers/auth'
import errors from './reducers/errors'
import password from './reducers/password'
import portfolio from './reducers/portfolio'
import product from './reducers/product'
import register from './reducers/register'
import transaction from './reducers/transaction'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default () => {
  // Setup middleware
  let middlewares = [thunk]

  if (process.env.NODE_ENV === 'development') {
    middlewares = [...middlewares, logger]
  }

  const store = createStore(
    combineReducers({
      account,
      app,
      auth,
      portfolio,
      product,
      password,
      register,
      transaction,
      errors
    }),
    composeEnhancers(applyMiddleware(...middlewares))
  )

  return store
}
